import { Decimal } from 'decimal.js';

export class PaymentOptionDto {
    index: number;

    name: string;

    dueDate: string;

    fromDate: string | null;

    toDate: string | null;

    weeks: number;

    price: Decimal;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawPaymentOptions: any) {
        this.index = rawPaymentOptions.index;
        this.name = rawPaymentOptions.name;
        this.dueDate = rawPaymentOptions.dueDate;
        this.fromDate = rawPaymentOptions.fromDate;
        this.toDate = rawPaymentOptions.toDate;
        this.weeks = rawPaymentOptions.weeks;
        this.price = new Decimal(rawPaymentOptions.price);
    }
}
